export const setSurveyPoint = (payload) => {
  return {
    type: "UPDATEPOINT",
    point: payload,
  };
};
export const setSurveyCommentTag = (payload) => {
  return {
    type: "UPDATECOMMENTTAG",
    payload: payload,
  };
};
